module.exports = __webpack_public_path__ + "img/loader-dark.59783d81.svg";